(function () {
  var PRODUCT_SECTION_CLASS = 'shopify-section--main-product';
  var GALLERY_SELECTOR = '.product-gallery';
  var IS_PDP = !!document.querySelector('.' + PRODUCT_SECTION_CLASS);

  // One shared cache for both PDP + cards
  var productCache = Object.create(null);

  // Width-capped warm helpers. Falls back to a local cap when the gallery asset
  // is not loaded, so this file never reintroduces raw originals on its own.
  var HS_CAP = 1000;
  function hsAtWidth(url, w) {
    if (window.__hausCardImg) return window.__hausCardImg.atWidth(url, w || HS_CAP);
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('width');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', String(w || HS_CAP));
      return u.toString();
    } catch (e) { return url; }
  }
  function hsApply(el, url) {
    if (!el || !url) return;
    if (window.__hausCardImg) { window.__hausCardImg.apply(el, url); return; }
    el.removeAttribute('srcset');
    el.src = hsAtWidth(url, HS_CAP);
  }


  /* ===================== Shared helpers ===================== */
  function fetchProduct(handle, signal) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) productCache[handle] = j; return j; });
  }

  function preload(url) {
    if (!url) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    // No img.decode() here. It forces the whole bitmap resident and is what
    // took the ASRV and Three Nails grids out of memory on iOS.
    return new Promise(function (resolve) {
      img.onload = img.onerror = resolve;
      img.src = hsAtWidth(url);
    });
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  /* ===================== PDP (AJAX) ===================== */
  if (IS_PDP) {
    var pv = {}; // PDP-only helpers

    pv.getMainSectionEl = function(){ return document.querySelector('.' + PRODUCT_SECTION_CLASS); };
    pv.getMainSectionId = function(){ var el = pv.getMainSectionEl(); return el ? el.id.replace(/^shopify-section-/,'') : null; };
    pv.getWrapperSectionIdFor = function(el){ var s = el && el.closest('.shopify-section'); return s ? s.id.replace(/^shopify-section-/,'') : null; };
    pv.urlWithSections = function(url, ids){ var u = new URL(url, window.location.origin); u.searchParams.set('sections', ids.join(',')); return u.toString(); };

    pv.setLoading = function(on){
      var secs = [];
      var main = pv.getMainSectionEl(); if (main) secs.push(main);
      document.querySelectorAll('[data-product-refresh-images]').forEach(function(n){ var s=n.closest('.shopify-section'); if (s) secs.push(s); });
      secs.forEach(function(sec){ sec.classList.toggle('is-loading', !!on); sec.setAttribute('aria-busy', on ? 'true':'false'); });
    };

    pv.getVariantPicker = function(){ var sec=pv.getMainSectionEl(); return sec && sec.querySelector('variant-picker'); };
    pv.getHandle = function(){
      var vp = pv.getVariantPicker();
      if (vp && vp.getAttribute('handle')) return vp.getAttribute('handle');
      var m = location.pathname.match(/\/products\/([^\/\?]+)/);
      return m ? m[1] : null;
    };

    pv.getSelectedSize = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return null;
      var sets = sec.querySelectorAll('fieldset.variant-picker__option, .variant-picker__option');
      for (var i=0;i<sets.length;i++){
        var fs = sets[i];
        var legend = fs.querySelector('legend, .variant-picker__option-info legend');
        var label = (legend && legend.textContent || '').trim().toLowerCase();
        if (label === 'size') {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked && checked.value) return checked.value;
        }
      }
      var any = sec.querySelector('input[type="radio"][name^="option"]:checked');
      return any ? any.value : null;
    };


pv.getColorOptionIndexFromDom = function(mainSection){
  if (!mainSection) return 0;

  // Find the option group that is actually rendering swatches (color)
  var groups = mainSection.querySelectorAll('fieldset[data-option-selector], fieldset.variant-picker__option, .variant-picker__option');
  for (var i = 0; i < groups.length; i++) {
    var g = groups[i];

    // Color swatches can be: .color-swatch, .thumbnail-swatch, or block swatches with a color chip
    if (!g.querySelector('.color-swatch, .thumbnail-swatch, .block-swatch__color')) continue;

    var any = g.querySelector('input[type="radio"][name^="option"], select[name^="option"]');
    if (!any) continue;

    var name = any.getAttribute('name') || '';
    var mm = name.match(/^option(\d+)$/);
    if (mm) return parseInt(mm[1], 10) || 0;
  }

  return 0;
};

pv.getSelectedOptionValueByIndex = function(mainSection, oi){
  if (!mainSection || !oi) return null;

  var checked = mainSection.querySelector('input[type="radio"][name="option' + oi + '"]:checked');
  if (checked) return checked.value || (checked.getAttribute('value') || '');

  var sel = mainSection.querySelector('select[name="option' + oi + '"]');
  if (sel) return sel.value || null;

  return null;
};

// Persist color choice across pack/product AJAX swaps
pv.getSelectedColor = function(){
  var sec = pv.getMainSectionEl();
  if (!sec) return null;

  var oi = pv.getColorOptionIndexFromDom(sec);
  if (!oi) return null;

  var val = pv.getSelectedOptionValueByIndex(sec, oi);
  if (!val) return null;

  return { index: oi, value: val };
};

    pv.getSelectedOptions = function(){
      var sec = pv.getMainSectionEl(); if(!sec) return [];
      var out = []; var i = 1, input;
      while ((input = sec.querySelector('input[type="radio"][name="option'+i+'"]:checked'))) {
        out.push(input.value);
        i++;
      }
      return out;
    };

    pv.selectVariantByOptions = function(options){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      for (var i = 0; i < options.length; i++) {
        var val = options[i];
        var input = sec.querySelector('input[type="radio"][name="option' + (i+1) + '"][value="' + CSS.escape(val) + '"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(function(){ pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync(); }, 0);
    };

    pv.setAtcStateFromVariant = function(variant){
      var sec = pv.getMainSectionEl(); if (!sec || !variant) return;
      var btn = sec.querySelector('form.shopify-product-form button[type="submit"]');
      if (!btn) return;
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-text-atc') || 'Add to Cart';
      } else {
        btn.disabled = true;
        if (!btn.hasAttribute('data-text-atc')) btn.setAttribute('data-text-atc', btn.textContent.trim());
        btn.textContent = 'Sold out';
      }
    };

    // Product JSON helpers using shared cache
    pv.prefetchProductJsonForHandle = function(handle){
      return fetchProduct(handle);
    };
    pv.getVariantIdFromOptions = function(handle, selectedOptions){
      var json = productCache[handle];
      if (!json || !Array.isArray(json.variants)) return null;
      return (json.variants.find(function(v){
        if (!v || !Array.isArray(v.options)) return false;
        for (var i=0;i<selectedOptions.length;i++){
          if ((v.options[i] || '') !== (selectedOptions[i] || '')) return false;
        }
        return true;
      }) || {}).id || null;
    };
    pv.getProductJsonCurrent = function(){
      var h = pv.getHandle();
      return h ? productCache[h] || null : null;
    };
    pv.getSizeOptionIndex = function(json){
      if (!json || !Array.isArray(json.options)) return 0;
      var idx = json.options.findIndex(function(n){ return String(n || '').toLowerCase() === 'size'; });
      return idx;
    };

    pv.getVariantIdInput = function(scope){
      var root = scope || pv.getMainSectionEl();
      if (!root) return null;
      return root.querySelector(
        'form.shopify-product-form input[name="id"]:not([disabled]), form[is="product-form"] input[name="id"]:not([disabled]), input[name="id"]:not([disabled])'
      ) || root.querySelector('input[name="id"]');
    };

    pv.forceHiddenInputToVariant = function(variantId){
      var sec = pv.getMainSectionEl(); if (!sec || !variantId) return;
      sec.querySelectorAll('form.shopify-product-form input[name="id"], form[is="product-form"] input[name="id"], input[name="id"]').forEach(function(input){
        if (String(input.value) !== String(variantId)) input.value = variantId;
      });
    };
    pv.getCurrentVariantIdFromHidden = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return null;
      var input = pv.getVariantIdInput(sec);
      return input && input.value ? input.value : null;
    };
    pv.updateUrlWithVariant = function(variantId){
      if (!variantId) return;
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variantId);
      history.replaceState(Object.assign({}, history.state || {}, {variantId:variantId, ajaxProduct:true}), '', u.pathname + u.search);
    };
    pv.ensureCorrectVariantIdSync = function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.ensureCorrectVariantIdAsync = async function(){
      var handle = pv.getHandle();
      var opts = pv.getSelectedOptions();
      if (!handle || !opts.length) return null;
      await pv.prefetchProductJsonForHandle(handle);
      var vid = pv.getVariantIdFromOptions(handle, opts);
      if (vid) {
        pv.forceHiddenInputToVariant(vid);
        pv.updateUrlWithVariant(vid);
      }
      return vid;
    };
    pv.afterVariantSynced = function(cb){
      var vid = pv.ensureCorrectVariantIdSync();
      if (vid) { cb(vid); return; }
      pv.ensureCorrectVariantIdAsync().then(function(vid2){ cb(vid2); });
    };


    // Force-dispatch a theme-style variant:change event after AJAX swaps.
    // This keeps <variant-option-value> (and any other listeners) in sync even when
    // we programmatically toggle option radios / hidden variant id.
    pv.getMainForm = function(){
      var sec = pv.getMainSectionEl();
      if (!sec) return null;
      return sec.querySelector('form[is="product-form"]') || sec.querySelector('form.shopify-product-form') || null;
    };

    pv.fixMainPriceBindings = function(){
  var sec = pv.getMainSectionEl();
  if (!sec) return;

  var form = pv.getMainForm();
  if (!form || !form.id) return;

  var formId = form.id;

  // Only touch price-related elements INSIDE the main PDP section.
  // These are typically custom elements that read variant data via the "form" attribute.
  var priceEls = sec.querySelectorAll(
    [
      'sale-price[form]',
      'compare-at-price[form]',
      'unit-price[form]',
      'price-list[form]',
      'variant-price[form]',
      'product-price[form]',
      '[data-price][form]',
      '[data-product-price][form]'
    ].join(',')
  );

  priceEls.forEach(function(el){
    if (el.getAttribute('form') !== formId) {
      el.setAttribute('form', formId);
    }
  });
};

// Fixes accidental form="[object HTMLInputElement]" on price custom elements
pv.fixPriceListFormAttrs = function fixPriceListFormAttrs(root) {
  if (!root) return;

  // Derive the main form id from reliable elements
  var formId = null;
  var probe =
    root.querySelector('on-sale-badge[form]') ||
    root.querySelector('variant-sku[form]') ||
    root.querySelector('buy-buttons[form]') ||
    root.querySelector('[data-atc-inventory-source] [form]');

  if (probe) formId = probe.getAttribute('form');

  if (!formId) {
    var f = root.querySelector('form[id^="product-form-"]');
    if (f && f.id) formId = f.id;
  }

  if (!formId) return;

  // Only touch PDP price widgets (avoid bundle/mini forms)
  var priceLists = root.querySelectorAll('price-list.price-list--product');
  priceLists.forEach(function(pl) {
    // Keep price-list aligned too if it has a form attr
    if (pl.hasAttribute('form')) {
      var plCur = pl.getAttribute('form') || '';
      if (!plCur || plCur.indexOf('[object') !== -1 || plCur !== formId) {
        pl.setAttribute('form', formId);
      }
    }

    var els = pl.querySelectorAll('sale-price[form], compare-at-price[form], unit-price[form]');
    els.forEach(function(el) {
      var cur = el.getAttribute('form') || '';
      if (!cur || cur.indexOf('[object') !== -1 || cur !== formId) {
        el.setAttribute('form', formId);
      }
    });
  });
};

// Normalize Shopify product JSON for theme custom-element event consumers
// (notably ProductGallery expects detail.product.media + option metadata).
pv.normalizeProductForEvent = function normalizeProductForEvent(json) {
  var p = (json && typeof json === 'object') ? json : {};
  var out = {};
  try {
    Object.keys(p).forEach(function(k){ out[k] = p[k]; });
  } catch(e) { out = p || {}; }

  // Ensure media is always an array to prevent theme errors.
  if (!Array.isArray(out.media)) out.media = [];

  // Some endpoints return options as strings; theme expects objects with name/position.
  if (Array.isArray(out.options) && out.options.length && typeof out.options[0] === 'string') {
    out.options = out.options.map(function(name, idx){
      return { name: String(name), position: idx + 1 };
    });
  } else if (!Array.isArray(out.options)) {
    out.options = [];
  }

  if (!out.title) out.title = document.title || '';
  return out;
};


    pv.dispatchVariantChangeFromId = function(variantId){
      try {
        if (!variantId) return;
        var form = pv.getMainForm();
        if (!form) return;

        var handle = pv.getHandle();
        var json = handle ? (productCache[handle] || null) : null;
        if (!json || !Array.isArray(json.variants)) return;

        var productForEvent = pv.normalizeProductForEvent(json);

        var next = json.variants.find(function(v){ return String(v && v.id) === String(variantId); }) || null;
        if (!next) return;

        var prevId = form.__pvLastVariantId;
        if (prevId && String(prevId) === String(variantId)) return; // already synced

        var prev = prevId ? (json.variants.find(function(v){ return String(v && v.id) === String(prevId); }) || null) : null;
        form.__pvLastVariantId = String(variantId);

        form.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { product: productForEvent, variant: next, previousVariant: (prev || {}) }
        }));
        // Fallback: force the visible option text to match the synced variant
        try {
          var sec = pv.getMainSectionEl();
          if (sec) {
            sec.querySelectorAll('variant-option-value').forEach(function(el){
              var f = el.getAttribute('for') || '';
              var m = f.match(/^option(\d+)$/);
              if (!m) return;
              var key = 'option' + m[1];
              if (next && next[key] != null) el.textContent = String(next[key]);
            });
          }
        } catch(_e) {}

      } catch(e) {}
    };
    pv.invalidateWairPopup = function(){
      document.querySelectorAll('.wair-modal, .wair-widget-modal, [data-wair-modal], .wair-overlay, iframe[src*="wair"]').forEach(function(node){
        if (node.closest('[data-wair-preserve]')) return;
        node.remove();
      });
    };
    pv.refreshWairButton = function(){
      var wrap = document.querySelector('[data-wair-preserve]');
      if (!wrap) return;
      var btn = wrap.querySelector('button, a, [role="button"]');
      if (!btn) return;
      var vid = pv.getCurrentVariantIdFromHidden();
      if (vid) {
        wrap.setAttribute('data-variant-id', vid);
        btn.setAttribute('data-variant-id', vid);
      }
      var tick = String(Date.now());
      wrap.setAttribute('data-wair-tick', tick);
      btn.setAttribute('data-wair-tick', tick);
    };
    pv.notifyWair = function(){
      try {
        if (window.WAIR && typeof window.WAIR.refresh === 'function') window.WAIR.refresh();
        else document.dispatchEvent(new Event('wair:refresh'));
      } catch(e){}
    };

    /**
     * Direct ATC-button sync (fallback for when variant:change doesn't fire).
     * Uses the product JSON to determine availability and update the button.
     */
    pv.forceAtcSync = function(variantId){
      if (!variantId) return;
      var sec = pv.getMainSectionEl(); if (!sec) return;
      var handle = pv.getHandle();
      var json = handle ? (productCache[handle] || null) : null;
      if (!json || !Array.isArray(json.variants)) return;

      var variant = json.variants.find(function(v){ return String(v && v.id) === String(variantId); });
      if (!variant) return;

      var bb = sec.querySelector('buy-buttons');
      if (!bb) return;
      var btn = bb.querySelector('button[type="submit"]');
      if (!btn) return;

      var isAvailable = !!variant.available;

      // disabled
      btn.disabled = !isAvailable;

      // label
      var labelEl = btn.querySelector('[data-atc-label]');
      if (labelEl) {
        var strings = (window.themeVariables && window.themeVariables.strings) || {};
        labelEl.textContent = isAvailable
          ? (strings.addToCartButton || 'Add to Cart')
          : (strings.soldOutButton || 'Sold out');
      }

      // bullet + price: only visible when in stock
      var bulletEl  = btn.querySelector('.bullet');
      var priceWrap = btn.querySelector('[data-atc-price]') || btn.querySelector('.atc-price');
      if (bulletEl)  bulletEl.hidden  = !isAvailable;
      if (priceWrap) priceWrap.hidden = !isAvailable;

      var subtextDiv = btn.querySelector('.button_subtext');
      var invSpan    = btn.querySelector('[data-atc-inventory]');
      var oosLabel   = btn.querySelector('[data-atc-oos-label]');
      var shipSuffix = btn.querySelector('[data-atc-ship-suffix]');
      var existingPo = btn.querySelector('.atc-preorder-msg');

      function _show(el){ if(el) el.hidden = false; }
      function _hide(el){ if(el) el.hidden = true; }

      if (isAvailable) {
        _show(invSpan); _hide(oosLabel); _show(shipSuffix); _hide(existingPo);
        btn.classList.remove('atc-state--soldout', 'atc-state--notify');
        btn.classList.add('atc-state--instock');

        var _priceEl   = btn.querySelector('[data-atc-price-final]');
        var _compareEl = btn.querySelector('[data-atc-price-compare]');
        if (_priceEl || _compareEl) {
          var _tv = window.themeVariables || {};
          var _s = _tv.settings || {};
          var _fmt = _s.currencyCodeEnabled ? _s.moneyWithCurrencyFormat : _s.moneyFormat;
          var _fn = typeof formatMoneyNoZeros === 'function' ? formatMoneyNoZeros : null;
          if (!_fn && typeof window.formatMoneyNoZeros === 'function') _fn = window.formatMoneyNoZeros;
          if (!_fn) _fn = function(c){ return '$' + (c / 100).toFixed(c % 100 ? 2 : 0); };
          var _showCmp = variant.compare_at_price > variant.price;
          if (_priceEl) _priceEl.textContent = _fn(variant.price, _fmt);
          if (_compareEl) {
            _compareEl.textContent = _fn(variant.compare_at_price, _fmt);
            _compareEl.hidden = !_showCmp;
          }
        }
      } else {
      }

      // force correct inventory span visible
      var btnInv = btn.querySelector('variant-inventory');
      if (btnInv) {
        var vid = String(variant.id);
        var spans = btnInv.querySelectorAll('[data-variant-id]');
        var activeStatus = '';
        spans.forEach(function(s){
          var match = String(s.getAttribute('data-variant-id')) === vid;
          s.toggleAttribute('hidden', !match);
          if (match) activeStatus = s.getAttribute('data-status') || '';
        });
        btnInv.className = 'inventory' + (activeStatus ? ' text-' + activeStatus : '');
      }

      // preorder subtext — read the server-rendered map directly from the button
      (function(){
        var preorderBtn = sec.querySelector('.preorder-button, #AddToCart-Preorder');
        var wsMap = null;
        if (preorderBtn && preorderBtn.dataset.wsMap) {
          try { wsMap = JSON.parse(preorderBtn.dataset.wsMap); } catch(e) {}
        }
        var hasPreorder = wsMap && wsMap[String(variant.id)];

        var _inv  = btn.querySelector('[data-atc-inventory]');
        var _oos  = btn.querySelector('[data-atc-oos-label]');
        var _ship = btn.querySelector('[data-atc-ship-suffix]');
        var _po   = btn.querySelector('.atc-preorder-msg');

        if (!isAvailable && hasPreorder) {
          btn.disabled = true;
          btn.removeAttribute('data-bis-proxy');
          btn.classList.remove('atc-state--instock', 'atc-state--notify');
          btn.classList.add('atc-state--soldout');
          _hide(_inv); _hide(_oos); _hide(_ship);
          _show(_po);
        } else if (!isAvailable) {
          // Sold out, no preorder → BIS notify
          btn.disabled = false;
          btn.setAttribute('data-bis-proxy', '');
          btn.classList.remove('atc-state--instock', 'atc-state--soldout');
          btn.classList.add('atc-state--notify');
          if (labelEl) labelEl.textContent = 'Notify When Available';
          _hide(_inv); _hide(_ship); _hide(_po);
          _show(_oos);
        } else {
          btn.removeAttribute('data-bis-proxy');
          btn.classList.remove('atc-state--soldout', 'atc-state--notify');
          btn.classList.add('atc-state--instock');
          _hide(_po);
        }
      })();
    };

    pv.normalizePreservedAccordions = function(root){
      root.querySelectorAll('details[is="accordion-disclosure"]').forEach(function(d){
        d.classList.remove('auto-open');
        d.style.height = null; d.style.overflow = null;
        d.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
        var c = d.querySelector(':scope > .accordion__content');
        if (c) { c.style.opacity = null; c.style.transform = null; }
      });
    };
    pv.executeAjaxScripts = function(root){
      if (!root) return;
      var scripts = root.querySelectorAll('script');
      if (!scripts || !scripts.length) return;

      for (var i = 0; i < scripts.length; i++) {
        var oldScript = scripts[i];
        var type = (oldScript.getAttribute('type') || '').toLowerCase();
        if (type && (type.indexOf('application/ld+json') === 0 || type.indexOf('application/json') === 0)) continue;

        var src = oldScript.getAttribute('src');
        var code = src ? '' : (oldScript.textContent || '');
        var marked = oldScript.hasAttribute('data-ajax-exec') || oldScript.hasAttribute('data-exec-on-ajax');
        var looksLikeBundle = !src && (code.indexOf('bundle-mini') !== -1 || code.indexOf('bundle-multi') !== -1);

        // Never re-execute core theme assets during an AJAX swap.
        // Re-running theme.js can break custom elements that rely on private fields.
        if (src) {
          var srcLower = String(src).toLowerCase();
          if (srcLower.indexOf('theme.js') !== -1 || srcLower.indexOf('vendor') !== -1) continue;
        }

        if (src && !marked) continue;
        if (!marked && !looksLikeBundle) continue;

        var s = document.createElement('script');
        for (var a = 0; a < oldScript.attributes.length; a++) {
          var attr = oldScript.attributes[a];
          if (attr && attr.name) s.setAttribute(attr.name, attr.value);
        }
        if (src) {
          s.src = src;
        } else {
          s.text = code;
        }
        try {
          oldScript.parentNode.replaceChild(s, oldScript);
        } catch (e) {
          console.warn('[pv] ajax script error', e);
          try { if (s && s.parentNode) s.parentNode.removeChild(s); } catch (_) {}
        }
      }
    };

    pv.replaceSectionHtml = function(sectionId, html){
      var current = document.querySelector('#shopify-section-' + sectionId);
      if (!current) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incoming = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incoming) return;
      if (current.classList.contains(PRODUCT_SECTION_CLASS)) {
        ['.accordion-group[data-preserve]','[data-wair-preserve]'].forEach(function (sel) {
          var oldList = current.querySelectorAll(sel);
          var newList = incoming.querySelectorAll(sel);
          for (var i = 0; i < newList.length; i++) {
            var keep = oldList[i], target = newList[i];
            if (keep && target) {
              pv.normalizePreservedAccordions(keep);
              target.replaceWith(keep);
            }
          }
        });

        /* ---- Preserve the galleries when the destination renders the same media ----
           Pack shells share media with their source product, so an AJAX swap would
           tear down a gallery that is already correct: same files, already decoded,
           already filtered to the selected colour by the #color_ alt rule. Rebuilding
           costs a repaint, and because that colour filtering runs in JS after render
           it also flashes every colour at once before settling.

           The PDP renders two galleries, desktop and mobile, so this pairs them by
           index and only preserves when every one of them matches. Element attributes
           are copied from the incoming node because `form` points at the destination
           product's form id and would otherwise go stale. Any difference in the media
           falls through to the cell-level pass below, and failing that to the
           original behavior, unchanged. */
        var pvCurGals = current.querySelectorAll('.product-gallery');
        var pvNewGals = incoming.querySelectorAll('.product-gallery');
        var pvGalleryKept = false;
        if (pvCurGals.length && pvCurGals.length === pvNewGals.length) {
          var pvAllMatch = true;
          for (var pvGi = 0; pvGi < pvNewGals.length; pvGi++) {
            var pvSig = pv.gallerySignature(pvCurGals[pvGi]);
            if (!pvSig || pvSig !== pv.gallerySignature(pvNewGals[pvGi])) { pvAllMatch = false; break; }
          }
          if (pvAllMatch) {
            for (var pvGj = 0; pvGj < pvNewGals.length; pvGj++) {
              (function (keep, target) {
                Array.prototype.forEach.call(target.attributes, function (attr) {
                  keep.setAttribute(attr.name, attr.value);
                });
                target.replaceWith(keep);
              })(pvCurGals[pvGj], pvNewGals[pvGj]);
            }
            pvGalleryKept = true;
          }
        }

        /* ---- Otherwise keep whatever individual cells still match ---- */
        if (!pvGalleryKept) {
          var pvOldCells = current.querySelectorAll('.product-gallery__media');
          var pvNewCells = incoming.querySelectorAll('.product-gallery__media');
          if (pvOldCells.length && pvNewCells.length) {
            /* Key on the FILE, not data-media-id: the same uploaded file attached to
               two products gets a different media id on each, so an id match misses
               every shared image (cotton 3-Pack and 6-Pack share ~30 of 35 shots and
               differ only in the pack flatlays). Move the already-decoded <img> into
               the incoming cell rather than swapping whole cells, so the new cell keeps
               its own media id for the thumbnail nav. */
            var pvOldByFile = {};
            Array.prototype.forEach.call(pvOldCells, function (c) {
              var f = pv.mediaCellFile(c);
              if (f && !pvOldByFile[f]) pvOldByFile[f] = c;
            });
            Array.prototype.forEach.call(pvNewCells, function (newCell) {
              var f = pv.mediaCellFile(newCell);
              if (!f) return;
              var oldCell = pvOldByFile[f];
              if (!oldCell) return;
              var oldImg = oldCell.querySelector('img');
              var newImg = newCell.querySelector('img');
              if (oldImg && newImg) newImg.replaceWith(oldImg);
            });
          }
        }

        /* ---- Pre-filter the incoming gallery by the selected colour ----
           The destination markup renders every colour's media visible; the colour
           filter normally runs after insertion, so all variants paint for a frame
           before the wrong ones hide. The incoming tree is still detached here, so
           apply the same #color_ alt filter now and it arrives already filtered. */
        (function () {
          var hz = function (v) { return String(v || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
          var tokens = {};
          incoming.querySelectorAll('.product-gallery__media img[alt*="#color"]').forEach(function (img) {
            var m = (img.getAttribute('alt') || '').match(/#color[_]([^#]*)/i);
            if (m) tokens[hz(m[1])] = true;
          });
          var colour = null;
          current.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
            var h = hz(i.value);
            if (!colour && tokens[h]) colour = h;
          });
          if (!colour) return;
          incoming.querySelectorAll('.product-gallery__media').forEach(function (el) {
            var img = el.querySelector('img');
            var m = ((img && img.getAttribute('alt')) || '').match(/#color[_]([^#]*)/i);
            var k = m ? hz(m[1]) : '';
            if (!k || k === colour) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
          });
        })();
      }
      current.replaceWith(incoming);
      pv.executeAjaxScripts(incoming);
    };

    /* Ordered fingerprint of a gallery's media: id plus file, so both the set and
       the order must match before two galleries count as interchangeable. */
    pv.gallerySignature = function (gal) {
      if (!gal) return '';
      var cells = gal.querySelectorAll('.product-gallery__media[data-media-id]');
      if (!cells.length) return '';
      var parts = [];
      Array.prototype.forEach.call(cells, function (c) {
        parts.push(pv.mediaCellFile(c));
      });
      return parts.join(',');
    };

    /* Identify a cell by its underlying FILE (path + version), ignoring the width
       params that differ between renders. Shared files match across products. */
    pv.mediaCellFile = function (cell) {
      var src = pv.mediaCellSrc(cell);
      if (!src) return '';
      var noQuery = src.split('?')[0];
      var file = noQuery.split('/').pop();
      var v = (src.match(/[?&]v=(\d+)/) || [])[1] || '';
      return file + '|' + v;
    };

    /* Resolve a gallery cell's underlying file, video first then image. */
    pv.mediaCellSrc = function (cell) {
      if (!cell) return '';
      var source = cell.querySelector('video source');
      if (source) return source.getAttribute('src') || '';
      var video = cell.querySelector('video');
      if (video) return video.getAttribute('src') || video.src || '';
      var img = cell.querySelector('img');
      return img ? (img.getAttribute('src') || '') : '';
    };
    pv.replaceSectionImagesOnly = function(sectionId, html){
      var currentRoot = document.querySelector('#shopify-section-' + sectionId);
      if (!currentRoot) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var incomingRoot = tmp.querySelector('#shopify-section-' + sectionId);
      if (!incomingRoot) return;

      var inImgs  = incomingRoot.querySelectorAll('img.Callout__Image');
      var curImgs = currentRoot.querySelectorAll('img.Callout__Image');
      var count = Math.min(inImgs.length, curImgs.length);
      for (var i=0;i<count;i++){
        var src = inImgs[i], dst = curImgs[i];
        ['data-src','data-srcset','data-sizes','data-widths','data-optimumx','alt'].forEach(function (name) {
          var val = src.getAttribute(name);
          if (val !== null) dst.setAttribute(name, val); else dst.removeAttribute(name);
        });
        dst.removeAttribute('src'); dst.removeAttribute('srcset');
        dst.classList.add('lazyload','lazyautosizes','Image--lazyLoad');
        dst.classList.remove('is-loaded','Image--lazyLoaded');
        if (window.lazySizes && lazySizes.loader) {
          lazySizes.loader.unveil(dst);
        }
      }
    };

    pv.hydrateLazyImgs = function(root){
      if (!root) return;
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.getAttribute('src') && img.dataset && img.dataset.src && img.dataset.src.indexOf('{width}') === -1) {
          img.setAttribute('src', img.dataset.src);
        }
        if (!img.getAttribute('srcset') && img.dataset && img.dataset.srcset && img.dataset.srcset.indexOf('{width}') === -1) {
          img.setAttribute('srcset', img.dataset.srcset);
        }
        if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
        img.addEventListener('load', function(){ img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function(){ img.classList.add('is-loaded'); }, { once: true });
      });
    };

    pv.reinitTheme = function(){
      var sec = pv.getMainSectionEl(); if (!sec) return;
      var id = sec.id.replace('shopify-section-','');

      try {
        document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: id } }));
        document.dispatchEvent(new CustomEvent('shopify:section:load',   { detail: { sectionId: id } }));
      } catch(e){}

      // Avoid re-instantiating theme custom elements during an AJAX swap.
      if (!pv.__isAjaxSwap) {
        try {
          if (window.Prestige && typeof window.Prestige.init === 'function') window.Prestige.init();
          if (window.theme && typeof window.theme.initProduct === 'function') window.theme.initProduct(sec);
        } catch(e){}
      }

      
var prefSize = (typeof window.__preferredSizeOnce !== 'undefined' && window.__preferredSizeOnce) ? window.__preferredSizeOnce : pv.getSelectedSize();
var prefColor = (typeof window.__preferredColorOnce !== 'undefined' && window.__preferredColorOnce) ? window.__preferredColorOnce : pv.getSelectedColor();

// reset one-shots
window.__preferredSizeOnce = null;
window.__preferredColorOnce = null;

var json = pv.getProductJsonCurrent();
var current = pv.getSelectedOptions();
var didApply = false;

if (current && current.length) {
  var tryOptions = current.slice();

  // Apply preferred color by DOM-detected option index (robust across products)
  var _pcv = (typeof prefColor === 'string') ? prefColor : (prefColor && prefColor.value);
  if (_pcv) {
    var colorOi = pv.getColorOptionIndexFromDom(sec); // 1-based
    if (colorOi && colorOi <= tryOptions.length) {
      tryOptions[colorOi - 1] = _pcv;
      didApply = true;
    }
  }

  // Apply preferred size only if the new product actually has a Size option
  if (prefSize && json && Array.isArray(json.options)) {
    var sizeIdx = pv.getSizeOptionIndex(json); // 0-based, -1 if not found
    if (sizeIdx !== -1 && sizeIdx < tryOptions.length) {
      tryOptions[sizeIdx] = prefSize;
      didApply = true;
    }
  }

  if (didApply) {
    pv.selectVariantByOptions(tryOptions);
  }
}

if (!didApply) {
  pv.ensureCorrectVariantIdSync() || pv.ensureCorrectVariantIdAsync();
}

pv.fixMainPriceBindings();

  // Fix bad form="[object HTMLInputElement]" on price custom elements
  pv.fixPriceListFormAttrs(pv.getMainSectionEl());
  setTimeout(function(){ pv.fixPriceListFormAttrs(pv.getMainSectionEl()); }, 0);
  setTimeout(function(){ pv.fixPriceListFormAttrs(pv.getMainSectionEl()); }, 150);

pv.afterVariantSynced(function(vid){
  pv.invalidateWairPopup();
  pv.refreshWairButton();
  pv.notifyWair();

  // Clear stale prevId flag so the dispatch always fires after an AJAX swap
  var _form = pv.getMainForm();
  if (_form) _form.__pvLastVariantId = null;

  pv.dispatchVariantChangeFromId(vid);

  // Fallback: if variant:change somehow didn't fire, force-sync the ATC button directly
  setTimeout(function(){
    pv.forceAtcSync && pv.forceAtcSync(vid);
  }, 80);

});

      try { window.dispatchEvent(new Event('resize')); } catch(e){}
      if (window.lazySizes && lazySizes.autoSizer && lazySizes.autoSizer.checkElems) lazySizes.autoSizer.checkElems();

      var g = sec.querySelector(GALLERY_SELECTOR);
      var lead = g && g.querySelector('.product-gallery__media.is-initial img, .product-gallery__media.is-active img');
      if (lead && lead.complete && lead.naturalWidth > 0) lead.classList.add('is-loaded');

      document.dispatchEvent(new Event('okendo:refresh'));
          // Re-bind Wait & Save (preorder) inside swapped markup
      pv.initWaitSave();

}
    /**
     * Wait & Save (preorder) re-bind for AJAX swaps.
     * Important: bind ONLY inside the MAIN PDP section so we don't interfere with bundle mini PDPs.
     */
    pv.initWaitSave = function() {
  // Re-bind Wait & Save (preorder) handlers after AJAX swaps.
  // Fixes: duplicate handlers (double add) + wrong-variant add when clicks happen fast.
  var main = pv.getMainSectionEl();
  if (!main) return;

  // Scan ONLY scripts inside the MAIN section (avoid binding inside bundle mini PDPs)
  var scripts = main.querySelectorAll('script');
  scripts.forEach(function(script) {
    if (script.__wsScanned) return;
    script.__wsScanned = true;

    var txt = script.textContent || '';
    if (txt.indexOf('AddToCart-Preorder') === -1) return;
    if (txt.indexOf('var map') === -1) return;

    // Extract the JS object literal from: var map = { ... };
    var match = txt.match(/var\s+map\s*=\s*(\{[\s\S]*?\})\s*;/);
    if (!match || !match[1]) return;

    var mapObj = null;
    try {
      mapObj = (new Function('return ' + match[1]))();
    } catch (e) {
      return;
    }
    if (!mapObj) return;

    // Scope to THIS product block
    var scope =
      script.closest('.product-info__block-item') ||
      script.closest('.product-info') ||
      script.parentElement ||
      main;

    var form =
      scope.querySelector('form[is="product-form"]') ||
      scope.querySelector('form.shopify-product-form') ||
      null;

    var preorderButton =
      scope.querySelector('.preorder-button') ||
      scope.querySelector('#AddToCart-Preorder') ||
      null;

    if (!form || !preorderButton) return;

    // Wipe any pre-existing handlers (theme inline script can bind on initial load)
    // Do this once per scope to avoid cloning loops.
    if (!scope.__wsBtnReplaced) {
      scope.__wsBtnReplaced = true;
      try {
        var clone = preorderButton.cloneNode(true);
        preorderButton.parentNode.replaceChild(clone, preorderButton);
        preorderButton = clone;
      } catch (e) {}
    }

    // Bind once
    if (preorderButton.__waitSaveBound) return;
    preorderButton.__waitSaveBound = true;
    preorderButton.dataset.wsBound = '1';

    var variantInput = pv.getVariantIdInput(form);
    if (!variantInput) return;

    function getPreorderId(baseId) {
      return (mapObj && mapObj[baseId]) ? mapObj[baseId] : null; // NO FALLBACK
    }

    function setPreorderVisible(on) {
      preorderButton.style.display = on ? '' : 'none';
      preorderButton.setAttribute('aria-hidden', on ? 'false' : 'true');
      preorderButton.tabIndex = on ? 0 : -1;
      if (!on) preorderButton.dataset.wsBusy = '0';
    }

    function syncPreorderVisibility() {
      var baseId = variantInput.value;
      var preorderId = getPreorderId(baseId);
      preorderButton.dataset.wsPreorderId = preorderId || '';
      setPreorderVisible(!!preorderId);
    }

    // Initial state
    syncPreorderVisibility();

    // Keep in sync on variant changes
    if (!scope.__wsSyncBound) {
      scope.__wsSyncBound = true;
      form.addEventListener('variant:change', syncPreorderVisibility, true);
      form.addEventListener('change', function(e) {
        var t = e.target;
        if (!t) return;
        var nm = t.getAttribute('name') || '';
        if (nm.indexOf('option') === 0 || nm === 'id') syncPreorderVisibility();
      }, true);
    }

    preorderButton.addEventListener('click', function(e) {
      // Prevent any other click handlers and accidental double submits
      if (preorderButton.dataset.wsBusy === '1') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }
      preorderButton.dataset.wsBusy = '1';

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var originalId = variantInput.value;
      var preorderId = getPreorderId(originalId);

      // If no mapping, just behave like normal ATC
      if (!preorderId) {
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        } finally {
          setTimeout(function(){ preorderButton.dataset.wsBusy = '0'; }, 600);
        }
        return;
      }

      // Clone the hidden "Pre-Order" property input from within this scope/button
      var tempPropInput = null;
      var sourceProp =
        (preorderButton.querySelector('#pre-order') ||
         scope.querySelector('#pre-order') ||
         scope.querySelector('input[name="properties[Pre-Order]"]'));

      if (sourceProp) {
        tempPropInput = sourceProp.cloneNode(true);
        tempPropInput.id = ''; // avoid duplicate id
        form.appendChild(tempPropInput);
      }

      // Disable any other line-item properties + selling plan so preorder submits clean (like old theme)
      var restoreExtras = (function disableExtras() {
        var keep = { 'properties[Pre-Order]': true };
        var changed = [];

        // Disable all other properties[...] inputs/selects/textareas
        form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(function(el) {
          var nm = el.getAttribute('name');
          if (!nm || keep[nm]) return;
          changed.push({ el: el, disabled: el.disabled });
          el.disabled = true;
        });

        // Disable selling_plan if present
        var sp = form.querySelector('[name="selling_plan"]');
        if (sp) {
          changed.push({ el: sp, disabled: sp.disabled });
          sp.disabled = true;
        }

        return function restore() {
          changed.forEach(function(x) { x.el.disabled = x.disabled; });
        };
      })();

      // Swap to preorder variant
      variantInput.value = preorderId;

      // Trigger the normal ATC so theme/Rebuy hooks still run.
      // IMPORTANT: temporarily enable the button so .click() fires the
      // ProductForm custom-element submit handler reliably.  When the
      // button is disabled, requestSubmit()/form.submit() can bypass the
      // custom-element on Safari (@ungap polyfill) and cause a native
      // POST → Shopify redirect → page refresh instead of AJAX add.
      var atcButton =
        form.querySelector('button[type="submit"][data-product-add-to-cart-button]') ||
        form.querySelector('button[type="submit"]');

      var wasDisabled = false;
      try {
        if (atcButton) {
          wasDisabled = atcButton.disabled;
          if (wasDisabled) atcButton.disabled = false;
          atcButton.click();
        } else if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      } finally {
        // Restore original state
        setTimeout(function() {
          variantInput.value = originalId;
          if (tempPropInput && tempPropInput.parentNode) {
            tempPropInput.parentNode.removeChild(tempPropInput);
          }
          if (typeof restoreExtras === 'function') restoreExtras();
          // Re-disable the ATC button if it was disabled before the preorder click
          if (atcButton && wasDisabled) atcButton.disabled = true;
          preorderButton.dataset.wsBusy = '0';
        }, 250);
      }
    }, true); // capture: block other delegated listeners
  });
};
;

    pv.getRefreshPlan = function(){
      var plan = [];
      var mainId = pv.getMainSectionId();
      if (mainId) plan.push({ id: mainId, mode: 'full' });
      // Transparent pricing derives every figure from the product price —
      // re-render it on product swaps so cost/save/bars follow the new product.
      document.querySelectorAll('.shopify-section--transparent-pricing').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'full' });
      });
      /* Product callouts/highlights read product.metafields.product.features and
         .details, so they are product-specific and must re-render on a swap or the
         previous product's callouts stick (5" short highlights on the 6.5" PDP). */
      document.querySelectorAll('.Product_Highlights').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'full' });
      });
      document.querySelectorAll('[data-product-refresh-images]').forEach(function (el) {
        var id = pv.getWrapperSectionIdFor(el);
        if (id && !plan.some(function(p){return p.id===id;})) plan.push({ id: id, mode: 'images' });
      });
      return plan;
    };

    pv.refreshTo = function(url){
      // Used by pv.reinitTheme to avoid heavy theme re-inits during an AJAX swap.
      pv.__isAjaxSwap = true;
      window.__pvHasAjaxSwapped = true; // persistent — Klaviyo breaks after AJAX swap
      window.__preferredSizeOnce = pv.getSelectedSize();
      window.__preferredColorOnce = (pv.getSelectedColor() ? pv.getSelectedColor().value : null);
      window.__preferredColorOnce = (pv.getSelectedColor() ? pv.getSelectedColor().value : null);

      var handle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (handle) fetchProduct(handle);

      var plan = pv.getRefreshPlan();
      if (!plan.length) { pv.__isAjaxSwap = false; window.location.href = url; return; }

      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(url, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          // Cross-template swap (e.g. product.tanks -> product.shell packs):
          // the Section Rendering API can't render another template's section
          // id, so the main section comes back empty. Patching around it would
          // leave the old product's prices/variants in the DOM — do a full
          // navigation instead.
          var mainPlan = plan.find(function(p){ return p.mode === 'full'; });
          if (mainPlan && !json[mainPlan.id]) { window.location.href = url; return; }

          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html);
          });

          history.replaceState({ ajaxProduct:true, sectionIds: ids }, '', url.pathname + url.search);

          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .catch(function(){ pv.__isAjaxSwap = false; window.location.href = url; })
        .finally(function(){ pv.__isAjaxSwap = false; pv.setLoading(false); });
    };

    // PDP-only listeners
    // Sync Bundle Multi when MAIN PDP variant changes (colors are variants, not separate products)
(function bindBundleSyncOnVariantChange(){
  function norm(v){ return String(v || '').trim().toLowerCase(); }

  function getColorOptionIndexFromDom(mainSection){
    if (!mainSection) return 0;

    // Find the option group that is actually rendering swatches
    var groups = mainSection.querySelectorAll('fieldset[data-option-selector], fieldset.variant-picker__option, .variant-picker__option');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];

      // Color swatches can be: .color-swatch, .thumbnail-swatch, or block swatches with a color chip
      if (!g.querySelector('.color-swatch, .thumbnail-swatch, .block-swatch__color')) continue;

      var any = g.querySelector('input[type="radio"][name^="option"], select[name^="option"]');
      if (!any) continue;

      var name = any.getAttribute('name') || '';
      var m = name.match(/^option(\d+)$/);
      if (m) return parseInt(m[1], 10) || 0;
    }

    return 0;
  }

  function getSelectedOptionValue(mainSection, oi){
    if (!mainSection || !oi) return null;

    var checked = mainSection.querySelector('input[type="radio"][name="option' + oi + '"]:checked');
    if (checked) return checked.value || (checked.getAttribute('value') || '');

    var sel = mainSection.querySelector('select[name="option' + oi + '"]');
    if (sel) return sel.value || null;

    return null;
  }

  function pushColorToBundles(colorValue){
    if (!colorValue) return;

    document.querySelectorAll('.bundle-multi').forEach(function(bm){
      if (typeof bm.__bmApplyMainColor === 'function') {
        bm.__bmApplyMainColor(colorValue);
      }
    });
  }

  document.addEventListener('variant:change', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // Only react to MAIN PDP form changes
    var mainSection = form.closest('.' + PRODUCT_SECTION_CLASS);
    if (!mainSection) return;

    var colorOi = getColorOptionIndexFromDom(mainSection);
    if (!colorOi) return;

    var d = e.detail || {};
    var newColor = d.variant ? (d.variant['option' + colorOi] || null) : null;
    var oldColor = d.previousVariant ? (d.previousVariant['option' + colorOi] || null) : null;

    // Fallback: read from DOM
    if (!newColor) newColor = getSelectedOptionValue(mainSection, colorOi);
    if (!newColor) return;

    // Ignore size-only changes
    if (oldColor && norm(oldColor) === norm(newColor)) return;

    pushColorToBundles(newColor);
  }, true);
})();

/**
 * ── ATC Button State Safety-Net ──────────────────────────────────────────
 * Runs after the theme's BuyButtons handler and the inventory custom-element
 * have processed `variant:change`.  Guarantees the button label, disabled
 * state, bullet / price visibility, ship-suffix and preorder subtext are
 * always correct — regardless of initial Liquid render or AJAX-swap timing.
 */
(function initAtcSync(){
  var SECTION_CLS = PRODUCT_SECTION_CLASS; // from outer scope

  var ATC_STATES = ['atc-state--instock', 'atc-state--soldout', 'atc-state--notify'];
  function setAtcState(btn, state) {
    ATC_STATES.forEach(function(c){ btn.classList.remove(c); });
    if (state) btn.classList.add('atc-state--' + state);
  }

  function showSpan(el){ if(el) el.hidden = false; }
  function hideSpan(el){ if(el) el.hidden = true; }

  function syncAtcButton(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var sec = form.closest('.' + SECTION_CLS);
    if (!sec) return;

    var variant = e.detail && e.detail.variant;
    var bb      = sec.querySelector('buy-buttons');
    if (!bb) return;

    var btn = bb.querySelector('button[type="submit"]');
    if (!btn) return;

    var isAvailable = !!(variant && variant.available);

    // ── Gather DOM refs ──
    var labelEl    = btn.querySelector('[data-atc-label]');
    var bulletEl   = btn.querySelector('.bullet');
    var priceWrap  = btn.querySelector('[data-atc-price]') || btn.querySelector('.atc-price');
    var subtextDiv = btn.querySelector('.button_subtext');
    var invSpan    = btn.querySelector('[data-atc-inventory]');
    var oosLabel   = btn.querySelector('[data-atc-oos-label]');
    var shipSuffix = btn.querySelector('[data-atc-ship-suffix]');
    var existingPo = btn.querySelector('.atc-preorder-msg');

    // ── Force correct inventory span inside variant-inventory ──
    if (variant) {
      var btnInv = btn.querySelector('[data-atc-inventory] variant-inventory') ||
                   btn.querySelector('variant-inventory');
      if (btnInv) {
        var vid = String(variant.id);
        var spans = btnInv.querySelectorAll('[data-variant-id]');
        var activeStatus = '';
        spans.forEach(function(s){
          var match = String(s.getAttribute('data-variant-id')) === vid;
          s.toggleAttribute('hidden', !match);
          if (match) activeStatus = s.getAttribute('data-status') || '';
        });
        btnInv.className = 'inventory' + (activeStatus ? ' text-' + activeStatus : '');
      }
    }

    // ── Check preorder status from the server-rendered map on the button ──
    var preorderBtn = sec.querySelector('.preorder-button, #AddToCart-Preorder');
    var wsMap = null;
    if (preorderBtn && preorderBtn.dataset.wsMap) {
      try { wsMap = JSON.parse(preorderBtn.dataset.wsMap); } catch(e) {}
    }
    var hasPreorder = variant && wsMap && wsMap[String(variant.id)];

    // ── Apply everything in one shot ──
    if (isAvailable) {
      btn.disabled = false;
      btn.removeAttribute('data-bis-proxy');
      setAtcState(btn, 'instock');
      if (labelEl) labelEl.textContent = window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addToCartButton
        ? window.themeVariables.strings.addToCartButton : 'Add to Cart';
      if (bulletEl)  bulletEl.hidden  = false;
      if (priceWrap) priceWrap.hidden = false;
      showSpan(invSpan); hideSpan(oosLabel); showSpan(shipSuffix); hideSpan(existingPo);

      var priceEl   = btn.querySelector('[data-atc-price-final]');
      var compareEl = btn.querySelector('[data-atc-price-compare]');
      if (priceEl || compareEl) {
        var tv = window.themeVariables || {};
        var sets = tv.settings || {};
        var fmt = sets.currencyCodeEnabled ? sets.moneyWithCurrencyFormat : sets.moneyFormat;
        var fmtFn = typeof formatMoneyNoZeros === 'function' ? formatMoneyNoZeros : null;
        if (!fmtFn && typeof window.formatMoneyNoZeros === 'function') fmtFn = window.formatMoneyNoZeros;
        if (!fmtFn) fmtFn = function(c){ return '$' + (c / 100).toFixed(c % 100 ? 2 : 0); };
        var showCmp = variant.compare_at_price > variant.price;
        if (priceEl) priceEl.textContent = fmtFn(variant.price, fmt);
        if (compareEl) {
          compareEl.textContent = fmtFn(variant.compare_at_price, fmt);
          compareEl.hidden = !showCmp;
        }
      }

    } else if (hasPreorder) {
      btn.disabled = true;
      btn.removeAttribute('data-bis-proxy');
      setAtcState(btn, 'soldout');
      if (labelEl) labelEl.textContent = window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutButton
        ? window.themeVariables.strings.soldOutButton : 'Sold out';
      if (bulletEl)  bulletEl.hidden  = true;
      if (priceWrap) priceWrap.hidden = true;
      hideSpan(invSpan); hideSpan(oosLabel); hideSpan(shipSuffix);
      showSpan(existingPo);

    } else if (variant) {
      // ── SOLD OUT, NO PREORDER → BIS NOTIFY ──
      btn.disabled = false;
      btn.setAttribute('data-bis-proxy', '');
      setAtcState(btn, 'notify');
      if (labelEl) labelEl.textContent = 'Notify When Available';
      if (bulletEl)  bulletEl.hidden  = true;
      if (priceWrap) priceWrap.hidden = true;
      hideSpan(invSpan); hideSpan(shipSuffix); hideSpan(existingPo);
      showSpan(oosLabel);

    } else {
      btn.disabled = true;
      btn.removeAttribute('data-bis-proxy');
      setAtcState(btn, null);
      if (labelEl) labelEl.textContent = window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.unavailableButton
        ? window.themeVariables.strings.unavailableButton : 'Unavailable';
      if (bulletEl)  bulletEl.hidden  = true;
      if (priceWrap) priceWrap.hidden = true;
      hideSpan(invSpan); hideSpan(oosLabel); hideSpan(shipSuffix); hideSpan(existingPo);
    }
  }

  // Runs synchronously on variant:change — registered after the theme's handler
  // so it corrects the preorder/sold-out state in the same paint frame.
  document.addEventListener('variant:change', function(e){
    syncAtcButton(e);

    // Force Klaviyo BIS button to stay hidden (theme.js shows it on sold-out)
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var block = form.closest('.product-info__block-item') || form.parentElement;
    if (!block) return;
    var bisBtn = block.querySelector('.klaviyo-bis-trigger');
    if (bisBtn) bisBtn.style.display = 'none';
  });

  // Also hide BIS on initial load + re-init Klaviyo binding
  function hideBisButtons(){
    document.querySelectorAll('.klaviyo-bis-trigger').forEach(function(btn){
      var block = btn.closest('.product-info__block-item');
      if (block) btn.style.display = 'none';
    });
    // Ask Klaviyo to bind so the modal still works when we simulate a click
    if (typeof window.__klaviyoBackInStockInit === 'function') {
      window.__klaviyoBackInStockInit();
    }
  }
  document.addEventListener('DOMContentLoaded', hideBisButtons);
  document.addEventListener('shopify:section:load', hideBisButtons);

  // Proxy: clicking the BIS-notify button triggers Klaviyo BIS modal
  document.addEventListener('click', function(e){
    var btn = e.target.closest('button[data-bis-proxy]');
    if (!btn) return;

    var sec = btn.closest('.' + SECTION_CLS);
    if (!sec) return;

    e.preventDefault();
    e.stopPropagation();

    // Re-init Klaviyo BIS (ensures trigger exists after AJAX swaps)
    if (typeof window.__klaviyoBackInStockInit === 'function') {
      window.__klaviyoBackInStockInit();
    }

    // Search block first, then section, then page
    var block = btn.closest('.product-info__block-item') || btn.closest('buy-buttons');
    if (!block) block = btn.closest('form');
    if (block) block = block.closest('.product-info__block-item') || block.parentElement;

    var bisBtn = (block && block.querySelector('.klaviyo-bis-trigger'))
      || (sec && sec.querySelector('.klaviyo-bis-trigger'))
      || document.querySelector('.klaviyo-bis-trigger');
    if (bisBtn) bisBtn.click();
  }, true);
})();


    document.addEventListener('click', function onPdpClick(e){
      var a = e.target.closest('a');
      if (!a) return;
      if (!a.closest('.variant-picker__option-values')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;

      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;

      if (!a.closest('.' + PRODUCT_SECTION_CLASS)) return;

      e.preventDefault();

      var url = new URL(href, window.location.origin);

      // If the target link doesn't include a variant, preserve the current color/size by
      // resolving the matching variant id for the destination product and appending ?variant=...
      var targetHandle = (url.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
      if (!targetHandle) return pv.refreshTo(url);

      var colorObj = pv.getSelectedColor();
      var currentColor = colorObj ? colorObj.value : null;
      var currentSize = pv.getSelectedSize();
      var currentOptions = pv.getSelectedOptions();

      pv.prefetchProductJsonForHandle(targetHandle).then(function(){
        var json = productCache[targetHandle];

        if (json && Array.isArray(json.variants) && json.variants.length) {
          var base = (json.variants[0] && Array.isArray(json.variants[0].options)) ? json.variants[0].options : [];
          var optionNames = Array.isArray(json.options) ? json.options : [];
          var len = optionNames.length || base.length || currentOptions.length;

          var desired = [];
          for (var i = 0; i < len; i++) {
            var name = String(optionNames[i] || '').toLowerCase();
            var v = null;

            if (name === 'color' || name === 'colour') v = currentColor;
            else if (name === 'size') v = currentSize;
            else v = currentOptions[i] || null;

            if (!v && base[i]) v = base[i];
            desired.push(v);
          }

          var vid = pv.getVariantIdFromOptions(targetHandle, desired);
          if (vid) url.searchParams.set('variant', vid);
        }

        pv.refreshTo(url);
      }).catch(function(){
        pv.refreshTo(url);
      });
    });

    window.addEventListener('popstate', function onPdpPopState(e){
      if (!e.state || !e.state.ajaxProduct) return;

      window.__preferredSizeOnce = pv.getSelectedSize();
      window.__preferredColorOnce = (pv.getSelectedColor() ? pv.getSelectedColor().value : null);

      var plan = pv.getRefreshPlan();
      if (!plan.length) return;
      var ids = plan.map(function(p){ return p.id; });
      var sectionsUrl = pv.urlWithSections(window.location.href, ids);

      pv.setLoading(true);
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (r){ return r.json(); })
        .then(function (json){
          // Cross-template history entry: section id won't render on this
          // template — reload for a correct page rather than a partial patch.
          var mainPlan = plan.find(function(p){ return p.mode === 'full'; });
          if (mainPlan && !json[mainPlan.id]) { window.location.reload(); return; }

          plan.forEach(function (p){
            var html = json[p.id]; if (!html) return;
            if (p.mode === 'images') pv.replaceSectionImagesOnly(p.id, html);
            else pv.replaceSectionHtml(p.id, html);
          });
          pv.hydrateLazyImgs(document);
          pv.reinitTheme();
        })
        .finally(function(){ pv.setLoading(false); });
    });

    document.addEventListener('DOMContentLoaded', function(){
      var h = pv.getHandle(); if (h) fetchProduct(h);
      pv.hydrateLazyImgs(document);
      pv.reinitTheme();
    });
  }

  /* ===================== Collection product cards (no rail, just preload) ===================== */
(function initCollectionCards(){
  var PREFETCH = {
    enable: true,
    maxPerCard: 8,
    prefetchSecondary: false, // lead image only, see the header comment
    viewportLookahead: 1.2,
    maxConcurrent: 4
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-card-swatches]').forEach(function (root) {
      var more = root.querySelector('[data-swatch-more]');
      var selected = root.querySelector('a.color-swatch.is-selected, a.thumbnail-swatch.is-selected');
      if (more && selected) more.href = selected.href;
    });
  });

  var inflight = 0;
  var queue = [];

  function schedule(task){
    queue.push(task);
    drain();
  }
  function drain(){
    if (inflight >= PREFETCH.maxConcurrent || !queue.length) return;
    inflight++;
    var fn = queue.shift();
    var done = function(){ inflight--; drain(); };
    try { var p = fn(); if (p && p.then) p.finally(done); else done(); } catch(e){ done(); }
  }

  function withinPdp(el){ return !!el.closest('.shopify-section--main-product'); }
  function card(el){ return el.closest('product-card.product-card'); }
  function leadImg(c){ return c ? c.querySelector('img.product-card__image--primary') : null; }
  function hoverImg(c){ return c ? c.querySelector('img.product-card__image--secondary') : null; }
  function mediaLink(c){ return c ? c.querySelector('a.product-card__media') : null; }
  function titleLink(c){ return c ? c.querySelector('a.product-title') : null; }
  function colorLink(c){ return c ? c.querySelector('a.product-color') : null; }   // NEW
  function setImg(el, src){ hsApply(el, src); }
  function handleFromHref(href){ var m=(href||'').match(/\/products\/([^\/\?]+)/); return m?m[1]:null; }

  // Prefer label from swatch DOM; fallback to product JSON later
  function swatchLabel(a){
    var s = (a.getAttribute('aria-label') || '').trim();
    if (s) return s;
    var sr = a.querySelector('.sr-only');
    return sr ? sr.textContent.trim() : '';
  }

  // Click: prevent nav, swap images, update color line only
  document.addEventListener('click', function(e){
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a) return;
    if (withinPdp(a)) return;

    var c = card(a); if (!c) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    var href = a.getAttribute('href');
    var group = a.closest('.variant-picker__color-swatches');
    var more = group && group.querySelector('[data-swatch-more]');
    if (more) more.setAttribute('href', href);

    var handle = handleFromHref(href);
    if (!handle) return;

    // Update links
    var mA = mediaLink(c); if (mA) mA.href = href;
    var tA = titleLink(c); if (tA) tA.href = href;          // keep title text as-is
    var cA = colorLink(c);                                   // color line link

    // Set color line from swatch label immediately
    var label = swatchLabel(a);
    if (cA) {
      if (label) cA.textContent = label;
      cA.href = href;
    }

    // Toggle selection UI
    var wrap = a.closest('.variant-picker__color-swatches');
    if (wrap) {
      wrap.querySelectorAll('a.color-swatch, a.thumbnail-swatch').forEach(function(n){ n.classList.remove('is-selected'); });
      a.classList.add('is-selected');
    }

    // Cancel any in-flight for this card
    if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch(_){}
    var ctrl = new AbortController(); c.__swatchCtrl = ctrl;
    c.__swatchToken = (c.__swatchToken || 0) + 1; var token = c.__swatchToken;

    // Fetch JSON → swap images; also use it as label fallback if needed
    fetch('/products/' + handle + '.js', { credentials:'same-origin', signal:ctrl.signal })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if (!j || token !== c.__swatchToken) return;
        var imgs = j.images || [];
        var primary = imgs[0] || '';
        var secondary = imgs[1] || primary;

        // Fallback color label from product title if swatch had none
        if (cA && !label) {
          var parts = String(j.title||'').split(' - ');
          var fallbackColor = parts.length > 1 ? parts.slice(1).join(' - ').trim() : '';
          if (fallbackColor) cA.textContent = fallbackColor;
        }

        var p1 = preload(primary);
        var p2 = preload(secondary);

        return Promise.allSettled([p1, p2]).then(function(){
          if (token !== c.__swatchToken) return;
          setImg(leadImg(c), primary);
          setImg(hoverImg(c), secondary);
          c.dataset.activeHandle = handle;
          // The card now shows a different product, so the swipe track has to
          // follow it. Falls through harmlessly when the gallery is off.
          if (window.__rebuildCardGalleryTrack) window.__rebuildCardGalleryTrack(c, j);
        });
      })
      .catch(function(){ /* swallow */ });
  }, true);

  // Keyboard a11y
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a || withinPdp(a)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); a.click();
  }, true);

  // Hover prefetch (unchanged)
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
    if (!a || withinPdp(a)) return;
    var handle = handleFromHref(a.getAttribute('href')); if (!handle) return;

    schedule(function(){
      return fetch('/products/' + handle + '.js', { credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if (!j) return;
          var imgs = j.images || [];
          var p = imgs[0] || '';
          var s = imgs[1] || p;
          var tasks = [];
          if (p) tasks.push(preload(p));
          if (PREFETCH.prefetchSecondary && s) tasks.push(preload(s));
          return Promise.allSettled(tasks);
        });
    });
  }, { passive: true });

    // Viewport prefetch: warm a handful of swatches for cards as they approach view
    if ('IntersectionObserver' in window && PREFETCH.enable) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting && entry.intersectionRatio === 0) return;
          var c = entry.target;
          var wrap = c.querySelector('[data-card-swatches]') || c;
          var links = wrap.querySelectorAll('.variant-picker__color-swatches a.color-swatch, .variant-picker__color-swatches a.thumbnail-swatch');
          var limit = Math.min(links.length, PREFETCH.maxPerCard);

          for (var i=0;i<limit;i++){
            (function(a){
              var h = handleFromHref(a.getAttribute('href')); if (!h) return;
              schedule(function(){
                return fetchProduct(h).then(function(j){
                  if (!j) return;
                  var imgs = j.images || [];
                  var p = imgs[0] || '';
                  var s = imgs[1] || p;
                  return PREFETCH.prefetchSecondary
                    ? Promise.allSettled([preload(p), preload(s)])
                    : preload(p);
                });
              });
            })(links[i]);
          }

          io.unobserve(c);
        });
      }, { root: null, rootMargin: Math.round((PREFETCH.viewportLookahead - 1) * 100) + '% 0px', threshold: [0, 0.01] });

      document.querySelectorAll('product-card.product-card').forEach(function(pc){ io.observe(pc); });
    }

    // Dynamic swatch count based on container width
    (function initDynamicSwatchCount() {
      var MOBILE_BREAKPOINT = 650; // Adjust to match your theme's breakpoint

      function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
      }

      function updateSwatchCount(container) {
        if (!container) return;
        
        var swatches = Array.from(container.querySelectorAll('a.color-swatch, a.thumbnail-swatch'));
        var moreBtn = container.querySelector('[data-swatch-more]');
        
        if (!swatches.length) return;

        var total = parseInt(container.getAttribute('data-total-colors')) || swatches.length;
        var maxMobile = parseInt(container.getAttribute('data-max-mobile')) || 5;
        var maxDesktop = parseInt(container.getAttribute('data-max-desktop')) || 9;
        var mobile = isMobile();
        var maxVisible = mobile ? maxMobile : maxDesktop;
        
        // Show all swatches initially
        swatches.forEach(function(s) { 
          s.style.display = ''; 
          s.classList.remove('hide-mobile');
        });
        if (moreBtn) moreBtn.style.display = '';
        
        // Force layout
        container.offsetHeight;
        
        var visible = 0;
        
        // On mobile, enforce strict limit from data attribute
        if (mobile) {
          for (var i = 0; i < swatches.length; i++) {
            if (i < maxVisible) {
              visible++;
            } else {
              swatches[i].style.display = 'none';
            }
          }
        } else {
          // On desktop, check for wrapping
          var firstRowTop = swatches[0].offsetTop;
          
          for (var i = 0; i < swatches.length; i++) {
            if (swatches[i].offsetTop === firstRowTop && i < maxVisible) {
              visible++;
            } else {
              // Hide this and all following swatches
              for (var j = i; j < swatches.length; j++) {
                swatches[j].style.display = 'none';
              }
              break;
            }
          }
        }

        // Update +N button
        if (moreBtn) {
          var remaining = total - visible;
          if (remaining > 0) {
            moreBtn.style.display = '';
            var countSpan = moreBtn.querySelector('[data-remaining-count]');
            if (countSpan) countSpan.textContent = remaining;
          } else {
            moreBtn.style.display = 'none';
          }
        }
      }

      function updateAllCards() {
        document.querySelectorAll('.variant-picker__color-swatches').forEach(updateSwatchCount);
      }

      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(updateAllCards, 300);
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAllCards, 100);
      });
    })();
  })();
})();


